import { action, computed, observable, reaction, runInAction } from 'mobx'
import PostModel from '@/models/PostModel.js'

export default class PostView {
  rootStore = null

  #reactions = []

  @observable accessor isInitializing = false
  @observable accessor isInitialized = false
  @observable accessor post = null

  constructor(rootStore) {
    this.rootStore = rootStore
    this.rootStore.registerDeconstructor(this.#_deconstructor)

    this.#reactions.push(reaction(() => this.post, this.#updateSeo))
  }

  #_deconstructor = () => {
    this.#reactions.forEach(x => x())
    this.#reactions = []
  }

  init = async () => {
    if (this.isInitializing) return

    runInAction(() => {
      this.isInitializing = true
    })

    await this.#loadData()

    runInAction(() => {
      this.isInitializing = false
      this.isInitialized = true
    })
  }

  @action
  reset = () => {
    this.post = null
    this.users.reset()
    this.seo.reset()
    this.isInitializing = false
    this.isInitialized = false
  }

  get api() {
    return this.rootStore.apiStore
  }

  get router() {
    return this.rootStore.routerStore
  }

  get seo() {
    return this.rootStore.seoStore
  }

  get users() {
    return this.rootStore.repositories.usersRepository
  }

  @computed
  get exists() {
    return Boolean(this.post)
  }

  #loadData = async () => {
    if (!this.isInitialized && !this.isInitializing) return

    const response = await this.api.getPost(this.router.params.id)
    if (!response?.data) return

    const post = new PostModel(this.rootStore, response.data)

    if (!post.user.isAuthUser) {
      await post.user.updateCategories()

      if (post.isUnpublishedCategory) return
    }

    runInAction(() => {
      this.post = post
    })
  }

  #updateSeo = () => {
    if (!this.exists) return

    this.seo.update({
      description: this.post.description,
      image: this.post.imagePreview ?? this.post.user.cover,
      title: this.post.title,
    })
  }
}
